import $ from 'jquery';
import SwiperCore, { Navigation, Pagination, EffectFade } from 'swiper/core';
import Swiper from 'swiper';
import LazyImages from './lazy-images';
export default class SliderWithPagination {
    static $slider = $('.js__image-with-content-slider');
    static swiper;
    static options = {
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        loop: SliderWithPagination.$slider.find('.swiper-slide').length > 1,
        watchOverflow: true,
    };
    static init() {
        if (!this.$slider.length) {
            return;
        }
        SwiperCore.use([Navigation, Pagination, EffectFade]);
        this.swiper = new Swiper(this.$slider.get(0), this.options);
        LazyImages.update();
    }
}
